import { axiosPost } from '@/api/AxiosApi';
import { sendRequest, EndpointPayload } from '@/api/AxiosRequest';
import { CreateCoinTypeRequest } from '@/types/stake-db';

const BALANCE_API_URL = process.env.REACT_APP_BALANCE_API_URL;

// 코인타입 생성
export const createCoinType = async (data: CreateCoinTypeRequest) => {
  const payload: EndpointPayload = {
    path: '/assetfi/admin/staking/coin-types',
    body: data,
    apiUrl: BALANCE_API_URL,
    skipConvert: true,
  };

  return await sendRequest(payload, 'createCoinType', axiosPost);
};
